import axios from 'axios';

import { IRequestConfig } from 'models/Axios';

import Services from './index.service';
import { SupplierProps, SupplierServiceProps } from 'models/Supplier';

export default class SupplierService extends Services<SupplierServiceProps, SupplierProps> {

  public get = () => {
    const config: IRequestConfig<SupplierProps> = {
      url: `/supplier/getAll`,
    };

    return this.httpRequest(config);
  };

  public async inviteSupplier(
    email?: string,
    supplierId?: string,
    roles?: string[]
  ) {
    const data = {
      email,
      supplierId,
      roles
    };

    return await axios
      .post(`${this.base_url}/users/invite-supplier`, data, {
        headers: { Authorization: `Bearer ${this.access_token()}` },
      })
      .then((result) => result)
      .catch((err) => err);
  }

  public async updateExternalUser(dataUpdated: any) {

    return await axios
      .put(`${this.base_url}/users/update/supplier`, dataUpdated, {
        headers: { Authorization: `Bearer ${this.access_token()}` },
      })
      .then((result) => result)
      .catch((err) => err);
  }
}